import { ref, onMounted } from 'vue';
import { useAnalytics } from './useAnalytics';
export function useCookieConsent() {
    const showConsentModal = ref(false);
    const showInfoModal = ref(false);
    const { initAnalyticsOnAccept, checkIfRussian } = useAnalytics();
    let analyticsLoaded = false;
    // При загрузке страницы проверяем, есть ли уже согласие
    onMounted(async () => {
        const hasConsent = localStorage.getItem('cookieConsent');
        if (!hasConsent) {
            showConsentModal.value = true;
        }
        else if (hasConsent === 'all' && !analyticsLoaded) {
            // Если согласие уже было - загружаем аналитику
            await initAnalyticsOnAccept();
            analyticsLoaded = true;
        }
    });
    const acceptAllCookies = async () => {
        localStorage.setItem('cookieConsent', 'all');
        showConsentModal.value = false;
        // В момент нажатия кнопки определяем IP и грузим нужную аналитику
        await initAnalyticsOnAccept();
        analyticsLoaded = true;
    };
    const acceptNecessaryOnly = () => {
        localStorage.setItem('cookieConsent', 'necessary');
        showConsentModal.value = false;
    };
    const showCookieInfo = () => {
        showInfoModal.value = true;
    };
    const hideCookieInfo = () => {
        showInfoModal.value = false;
    };
    return {
        showConsentModal,
        showInfoModal,
        acceptAllCookies,
        acceptNecessaryOnly,
        showCookieInfo,
        hideCookieInfo
    };
}
